import React, { useMemo, useState, useEffect } from "react";
import "../../styles/admin.css";
import Pagination from "./pagination";
import {
  fetchSubscriberList,
  fetchSubscriberdetail,
  fetchAdminCreateEditApi,
  fetchMasterlist,
  fetchProductEditApi,
  fetchProductDeleteApi,
  fetchSubcriptionRefundApi
} from "../../api/api";
import DateTimeField from "./Datetime";
import {convertUTCToLocalFormatted } from "../../helper/index";

export default function SubscriberPanel() {
  const userType = sessionStorage.getItem("usertypeid");
  const [show, setShow] = useState(false);
  const [selectedSubscriber, setSelectedSubscriber] = useState(null);
  const [selectedProductSubscriber, setSelectedProductSubscriber] = useState(null);
  const [editProduct, setEditProduct] = useState(null);
  const [rows, setRows] = useState([]);
  const [query, setQuery] = useState("");
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [sortConfig, setSortConfig] = useState({ key: null, direction: "asc" });
  const [showModal, setShowModal] = useState(false);
  const [adderror, setAdderror] = useState({});
  const [successMsg, setSuccessMsg] = useState("");
  const [errorMsg, setErrorMsg] = useState("");
  const [productListist, setProductList] = useState([]);
  const [subscriptionsList, setSubscriptionsList] = useState([]);
  const [productSubscriptionsList, setProductSubscriptionsList] = useState([]);
  const [cancelbtn, setCancelbtn ] = useState(false)
  const [editbtn, setEditbtn ] = useState(false)
  const [formData, setFormData] = useState({
    subscriberid: 0,
    username: "",
    password: "",
    firstname: "",
    surname: "",
    mobilenumber: "",
    usertypeid: 2,
    userstatusid: 2,
    subscriberstatusid: 0,
  });
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [successrefundMsg, setSuccessrefundMsg] = useState("");
  const [errorrefundMsg, setErrorrefundMsg] = useState("");
  const [loadingrefund, setLoadingrefund] = useState(false);
  const [userTypeData, setUserTypeData ] = useState([])

  const handleSort = (key) => {
    let direction = "asc";
    if (sortConfig.key === key && sortConfig.direction === "asc") {
      direction = "desc";
    }
    setSortConfig({ key, direction });
  };

  // ✅ Filtering + Sorting
  const filtered = useMemo(() => {
    const q = query.trim().toLowerCase();
    let result = rows.filter(
      (r) =>
        r.username.toLowerCase().includes(q) ||
        r.firstname.toLowerCase().includes(q) ||
        r.surname.toLowerCase().includes(q) ||
        r.country.toLowerCase().includes(q) ||
        r.susbcriberstatus.toLowerCase().includes(q) ||
        r.userstatus.toLowerCase().includes(q)
    );

    if (sortConfig.key) {
      result = [...result].sort((a, b) => {
        const aVal = a[sortConfig.key] ?? "";
        const bVal = b[sortConfig.key] ?? "";

        if (typeof aVal === "number" && typeof bVal === "number") {
          return sortConfig.direction === "asc" ? aVal - bVal : bVal - aVal;
        }
        return sortConfig.direction === "asc"
          ? String(aVal).localeCompare(String(bVal))
          : String(bVal).localeCompare(String(aVal));
      });
    }

    return result;
  }, [rows, query, sortConfig]);

  const totalPages = Math.max(1, Math.ceil(filtered.length / pageSize));
  const pageRows = filtered.slice((page - 1) * pageSize, page * pageSize);

  useEffect(() => {
    const loadSubscribers = async () => {
      setLoading(true);
      try {
        const response = await fetchSubscriberList();
        setRows(response.data || []);
        setLoading(false);
      } catch (error) {
        console.error("Error fetching subscriber data:", error);
      }
    };
    loadSubscribers();

    const loadMasterData = async () => {
      try {
        const response = await fetchMasterlist();
        setProductList(response.data.products || []);
        setSubscriptionsList(response.data.subscriptions || []);
        setProductSubscriptionsList(
          response.data.productsubscriptionstatus || []
        );
        setUserTypeData(response.data.usertype)
      } catch (error) {
        console.error("Error fetching subscriber data:", error);
      }
    };
    loadMasterData();
  }, []);

  const handleEdit = (row) => {
    setEditbtn(true)
    setSelectedSubscriber(row);
    const loadSubscribersdetail = async () => {
      try {
        const response = await fetchSubscriberdetail(row.subscriberid);
        setSelectedProductSubscriber(response.data || []);
      } catch (error) {
        console.error("Error fetching subscriber data:", error);
      }
    };
    loadSubscribersdetail();
    setEditbtn(false)
    setShow(true);
  };

  const handleDelete = (row) => {
    const loadSubscribersdeletedetail = async () => {
      setCancelbtn(true)
      try {
        const response = await fetchProductDeleteApi(row.subscriberid);
        if (response?.statuscode === 200) {
          setSuccessMsg("User deleted successfully!");
          setCancelbtn(false)

        const refreshed = await fetchSubscriberList();
        setRows(refreshed.data || []);

        setTimeout(() => setSuccessMsg(""), 3000);
      } else {
        setErrorMsg(response?.message || "Failed to delete user.");
        setTimeout(() => setErrorMsg(""), 3000);
      }
      } catch (error) {
        console.error("Error fetching subscriber data:", error);
         setErrorMsg("Something went wrong while deleting the user.");
        setTimeout(() => setErrorMsg(""), 3000);
      }
    };
    loadSubscribersdeletedetail();
  };

  const handleSelectProduct = (product) => {
    setEditProduct({ ...product });
  };

  const handleCancelEditProduct = () => {
    setEditProduct(null);
  };

  const handleSubmitProduct = async (e) => {
    // const updatedEditProduct = {...editProduct, paypalsubscriptionid: selectedProductSubscriber.paypalsubscriptionid}
    e.preventDefault();
    setSuccessMsg("");
    setErrorMsg("");
    try {
      const response = await fetchProductEditApi(editProduct);
      if (response?.statuscode === 200) {
        setSuccessMsg("Edit Product successfully!");
        setEditProduct(null);

        try {
          const response = await fetchSubscriberdetail(
            editProduct.subscriberid
          );
          setSelectedProductSubscriber(response.data || []);
        } catch (error) {
          console.error("Error fetching subscriber data:", error);
        }
        setTimeout(() => {
          setSuccessMsg("");
        }, 3000);
      } else {
        setErrorMsg(response?.message || "Failed to save user.");
        setTimeout(() => {
          setErrorMsg("");
          // setShow(false);
        }, 3000);
      }
    } catch (error) {
      console.error("Error saving user:", error);
      setErrorMsg("Something went wrong while saving the user.");
    }
  };


  const handleSubmitUserEdit = async (e) => {

    e.preventDefault();
    setSuccessMsg("");
    setErrorMsg("");
    try {
      const payload = {
        subscriberid: selectedSubscriber.subscriberid,
        username: selectedSubscriber.username,
        password: selectedSubscriber.password || "",
        firstname: selectedSubscriber.firstname,
        surname: selectedSubscriber.surname,
        mobilenumber: selectedSubscriber.mobilenumber,
        usertypeid: selectedSubscriber.usertypeid || 0,
        userstatusid: selectedSubscriber.userstatusid,
        subscriberstatusid: selectedSubscriber.subscriberstatusid,
      };
      const response = await fetchAdminCreateEditApi(payload);

      // If API returns something like { success: true }
      if (response?.statuscode === 200) {
        setSuccessMsg("Edit User successfully!");
        const refreshed = await fetchSubscriberList();
        setRows(refreshed.data || []);
        setTimeout(() => {
          setSuccessMsg("");
          // setShow(false);
        }, 3000);
      } else {
        setErrorMsg(response?.message || "Failed to save user.");
        setTimeout(() => {
          setErrorMsg("");
          // setShow(false);
        }, 3000);
      }
    } catch (error) {
      console.error("Error saving user:", error);
      setErrorMsg("Something went wrong while saving the user.");
    }
  };

  // handle submit
  const handleSubmitUser = async (e) => {
    e.preventDefault();
    setSuccessMsg("");
    setErrorMsg("");

    try {
      const response = await fetchAdminCreateEditApi(formData);

      // If API returns something like { success: true }
      if (response?.statuscode === 200) {
        setShowModal(false);
        setSuccessMsg("User saved successfully!");
        const refreshed = await fetchSubscriberList();
        setRows(refreshed.data || []);
        setTimeout(() => setSuccessMsg(""), 3000);
      } else {
        setErrorMsg(response?.message || "Failed to save user.");
      }
    } catch (error) {
      console.error("Error saving user:", error);
      setErrorMsg("Something went wrong while saving the user.");
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  // 🔒 Access Control
  if (userType !== "1") {
    return (
      <div className="no-access">
        <h2>🚫 You are not authorized to access this page</h2>
      </div>
    );
  }

  const handleRefundProduct = (subscriberid) => {
    setLoadingrefund(true)
    const loadSubscribersrefunddetail = async () => {
      try {
        const response = await fetchSubcriptionRefundApi(subscriberid);
        if (response?.statuscode === 200) {
          setSuccessrefundMsg("Refund successfully!");

          setTimeout(() => setSuccessrefundMsg(""), 3000);
          setLoadingrefund(false)

      } else {
        setErrorrefundMsg(response?.message || response?.details[0]?.description || "Failed to refund.");
        setTimeout(() => setErrorrefundMsg(""), 3000);
        setLoadingrefund(false)
      }
      } catch (error) {
         setErrorrefundMsg("Something went wrong while refund the user.");
        setTimeout(() => setErrorrefundMsg(""), 3000);
      }
    };
    loadSubscribersrefunddetail();
  };


  return (
    <div className="admin-panel">
      <div className="header">
        <div className="header-div-show-page">
          <h1>Subscribers</h1>
          {/* ✅ Show per page selector */}
          <label className="show-per-page">
            Show per page:{" "}
            <select
              value={pageSize}
              onChange={(e) => {
                setPageSize(Number(e.target.value));
                setPage(1);
              }}
              className="show-select"
            >
              <option value={5}>5</option>
              <option value={10}>10</option>
              <option value={20}>20</option>
              <option value={50}>50</option>
            </select>
          </label>
        </div>
        <div className="header-div-show-page">
          <button className="add-user-btn" onClick={() => setShowModal(true)}>
            + Add User
          </button>
          <input
            value={query}
            onChange={(e) => {
              setQuery(e.target.value);
              setPage(1);
            }}
            placeholder="Search..."
            className="search-input"
          />
        </div>
      </div>
      {successMsg && (
          <p style={{ color: "green", textAlign: "center", fontSize: "16px" }}>
            {successMsg}
          </p>
        )}
        {errorMsg && (
          <p style={{ color: "red", textAlign: "center", fontSize: "14px" }}>
            {errorMsg}
          </p>
        )}
        <div class="table-container">
          <table className="custom-table">
            
            <thead>
              <tr>
                <th onClick={() => handleSort("subscriberid")}>
                  Subscriber Id
                  <span className="sort-icon">
                    {sortConfig.key === "subscriberid"
                      ? sortConfig.direction === "asc"
                        ? "▲"
                        : "▼"
                      : "↕"}
                  </span>
                </th>
                <th onClick={() => handleSort("username")}>
                  UserName
                  <span className="sort-icon">
                    {sortConfig.key === "username"
                      ? sortConfig.direction === "asc"
                        ? "▲"
                        : "▼"
                      : "↕"}
                  </span>
                </th>
                <th onClick={() => handleSort("firstname")}>
                  First Name
                  <span className="sort-icon">
                    {sortConfig.key === "firstname"
                      ? sortConfig.direction === "asc"
                        ? "▲"
                        : "▼"
                      : "↕"}
                  </span>
                </th>
                <th onClick={() => handleSort("surname")}>
                  Last Name
                  <span className="sort-icon">
                    {sortConfig.key === "surname"
                      ? sortConfig.direction === "asc"
                        ? "▲"
                        : "▼"
                      : "↕"}
                  </span>
                </th>
                <th onClick={() => handleSort("country")}>
                  Country
                  <span className="sort-icon">
                    {sortConfig.key === "country"
                      ? sortConfig.direction === "asc"
                        ? "▲"
                        : "▼"
                      : "↕"}
                  </span>
                </th>
                <th onClick={() => handleSort("dateadded")}>
                  Registration Date
                  <span className="sort-icon">
                    {sortConfig.key === "dateadded"
                      ? sortConfig.direction === "asc"
                        ? "▲"
                        : "▼"
                      : "↕"}
                  </span>
                </th>
                <th onClick={() => handleSort("susbcriberstatus")}>
                  Subscriber Status
                  <span className="sort-icon">
                    {sortConfig.key === "susbcriberstatus"
                      ? sortConfig.direction === "asc"
                        ? "▲"
                        : "▼"
                      : "↕"}
                  </span>
                </th>
                <th onClick={() => handleSort("userstatus")}>
                  User Status
                  <span className="sort-icon">
                    {sortConfig.key === "userstatus"
                      ? sortConfig.direction === "asc"
                        ? "▲"
                        : "▼"
                      : "↕"}
                  </span>
                </th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr>
                  <td colSpan={10} style={{ padding: "20px" }}>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        width: "100%",
                      }}
                    >
                      <svg
                        width="40"
                        height="40"
                        viewBox="0 0 50 50"
                        aria-hidden="true"
                      >
                        <circle
                          cx="25"
                          cy="25"
                          r="20"
                          stroke="rgba(0,0,0,0.12)"
                          strokeWidth="4"
                          fill="none"
                        />
                        <circle
                          cx="25"
                          cy="25"
                          r="20"
                          stroke="#2b3245"
                          strokeWidth="4"
                          strokeLinecap="round"
                          fill="none"
                          strokeDasharray="31.4 31.4"
                        >
                          <animateTransform
                            attributeName="transform"
                            type="rotate"
                            from="0 25 25"
                            to="360 25 25"
                            dur="1s"
                            repeatCount="indefinite"
                          />
                        </circle>
                      </svg>
                    </div>
                  </td>
                </tr>
              ) : pageRows.length === 0 ? (
                <tr>
                  <td
                    colSpan={10}
                    className="no-data"
                    style={{
                      textAlign: "center",
                      padding: "20px",
                      fontSize: "14px",
                    }}
                  >
                    No results
                  </td>
                </tr>
              ) : null}
              {pageRows.map((r) => (
                <tr key={r.subscriberid}>
                  <td>{r.subscriberid}</td>
                  <td>{r.username}</td>
                  <td>{r.firstname}</td>
                  <td>{r.surname}</td>
                  <td>{r.country}</td>
                  <td>{convertUTCToLocalFormatted(r.dateadded)}</td>
                  <td>{r.susbcriberstatus}</td>
                  <td>{r.userstatus}</td>
                  <td>
                    <div className="btn-row-admin">
                      <button onClick={() => handleEdit(r)} disabled={editbtn} className="btn-admin-sm">{editbtn ? "Editing..."  :  "Edit"}</button>
                      <button onClick={() => handleDelete(r)} disabled={cancelbtn} className="btn-admin-sm-delete">{cancelbtn ? "Deleting..."  :  "Delete"}</button>
                    </div>
                  </td>

                </tr>
              ))}
            </tbody>
          </table>
        </div>

      <Pagination
        totalPages={totalPages}
        currentPage={page}
        setPage={setPage}
        totaldata={filtered.length}
        pageRowdata={pageRows.length}
      />



      {/* Modal */}
      {show && selectedSubscriber && selectedProductSubscriber && (
        <div className="modal-overlay">
          <div className="modal">
            <div className="modal-header">
              <h2>Edit Subscriber Detail</h2>
              <span
                className="modal-close"
                onClick={() => {
                  setShow(false);
                  setEditProduct(null);
                }}
              >
                &times;
              </span>
            </div>

            {selectedSubscriber && selectedProductSubscriber && (
              <div className="modal-body">
                {successMsg && (
                  <p
                    style={{
                      color: "green",
                      textAlign: "center",
                      fontSize: "14px",
                    }}
                  >
                    {successMsg}
                  </p>
                )}
                {errorMsg && (
                  <p
                    style={{
                      color: "red",
                      textAlign: "center",
                      fontSize: "14px",
                    }}
                  >
                    {errorMsg}
                  </p>
                )}
                {successrefundMsg && (
                  <p
                    style={{
                      color: "green",
                      textAlign: "center",
                      fontSize: "14px",
                    }}
                  >
                    {successrefundMsg}
                  </p>
                )}
                {errorrefundMsg && (
                  <p
                    style={{
                      color: "red",
                      textAlign: "center",
                      fontSize: "14px",
                    }}
                  >
                    {errorrefundMsg}
                  </p>
                )}
                <form className="form-grid" onSubmit={handleSubmitUserEdit}>
                  <div className="form-grid">
                    <label>
                      Subscriber
                      <input value={selectedSubscriber.subscriberid} readOnly />
                    </label>
                    <label>
                      First Name
                      <input value={selectedSubscriber.firstname} readOnly />
                    </label>
                    <label>
                      Last Name
                      <input value={selectedSubscriber.surname} readOnly />
                    </label>
                    <label>
                      Username
                      <input value={selectedSubscriber.username} readOnly />
                    </label>
                    <label>
                      Mobile Number
                      <input value={selectedSubscriber.mobilenumber} readOnly />
                    </label>
                    <label>
                      User Status
                      <select
                        value={selectedSubscriber.userstatusid}
                        onChange={(e) =>
                          setSelectedSubscriber((prev) => ({
                            ...prev,
                            userstatusid: e.target.value,
                          }))
                        }
                      >
                        <option value="1">Active</option>
                        <option value="2">Inactive</option>
                      </select>
                    </label>
                    <button className="btn-submit">Submit</button>
                  </div>
                </form>

                {/* ✅ Always show subscription list */}
                <h4>User Product Subscription List</h4>
                <table className="subscription-table">
                  <thead>
                    <tr>
                      <th>Id</th>
                      <th>Paypal Email</th>
                      <th>Product</th>
                      <th>Subscription Type</th>
                      <th>Product Subscription Status</th>
                      <th>Subscription Start</th>
                      <th>Subscription End</th>
                      <th>Next Payment Due</th>
                      <th>Recurring</th>
                      <th>Total Cost</th>
                      {/* <th>Vat</th> */}
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {selectedProductSubscriber.map((s) => (
                      <tr key={s.productsubscriptionid}>
                        <td>{s.productsubscriptionid}</td>
                        <td>{s.paypalemail}</td>
                        <td>{s.productname}</td>
                        <td>{s.subscription}</td>
                        <td>{s.status}</td>
                        <td>
                          {s.subscriptionstart === null ? (
                              <span className="dash">-</span>
                            ) : (
                              convertUTCToLocalFormatted(s.subscriptionstart)
                          )}
                        </td>
                        <td>
                          {s.subscriptionend === null ? (
                            <span className="dash">-</span>
                          ) : (
                            convertUTCToLocalFormatted(s.subscriptionend)
                          )}
                          
                        </td>
                        <td>
                          {s.renewaldate === null ? (
                            <span className="dash">-</span>
                          ) : (
                            convertUTCToLocalFormatted(s.renewaldate)
                          )}
                        </td>
                        <td>{s.recurring ? "True" : "False"}</td>
                        <td>{s.totalcost}</td>
                        {/* <td>{s.vat}</td> */}
                        <td>
                          <div style={{ display: "flex", gap: "10px", width:'150px' }}>
                            <button
                              className="btn-select"
                              onClick={() => handleSelectProduct(s)}
                            >
                              Select
                            </button>
                            {
                            s.productname === 'Free' || s.status === 'Cancelled' ? '' :
                            <button
                              className="btn-select-refund"
                              onClick={() => handleRefundProduct(s.paypalsubscriptionid)}
                            >
                              {loadingrefund ? 'Refunding...': 'Refund'}
                            </button>
                            }
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>

                {/* ✅ Show edit form only when product selected */}
                {editProduct && (
                  <div className="edit-form-grid">
                    <label>
                      Product Subscription Id
                      <input
                        value={editProduct?.productsubscriptionid}
                        readOnly
                      />
                    </label>

                    {/* Product select */}
                    <label>
                      Product
                      <select
                        value={editProduct?.productid || ""}
                        onChange={(e) =>
                          setEditProduct({
                            ...editProduct,
                            productid: e.target.value,
                          })
                        }
                      >
                        <option value="">Select Product</option>
                        {productListist.map((p) => (
                          <option key={p.id} value={p.id}>
                            {p.name}
                          </option>
                        ))}
                      </select>
                    </label>

                    {/* Subscription select */}
                    <label>
                      Subscription
                      <select
                        value={editProduct?.subscriptionid || ""}
                        onChange={(e) => {
                          const selectedIndex = e.target.selectedIndex;
                          const selectedText =
                            e.target.options[selectedIndex].text;
                          setEditProduct({
                            ...editProduct,
                            subscriptionid: e.target.value,
                            subscription: selectedText,
                          });
                        }}
                      >
                        <option value="">Select Subscription</option>
                        {subscriptionsList.map((s) => (
                          <option
                            key={s.subscriptionid}
                            value={s.subscriptionid}
                          >
                            {s.subscription}
                          </option>
                        ))}
                      </select>
                    </label>

                    {/* Product Subscription select */}
                    <label>
                      Product Subscription Status
                      <select
                        value={editProduct?.productsubscriptionstatusid || ""}
                        onChange={(e) =>
                          setEditProduct({
                            ...editProduct,
                            productsubscriptionstatusid: e.target.value,
                          })
                        }
                      >
                        <option value="">Select Product Subscription</option>
                        {productSubscriptionsList.map((ps) => (
                          <option key={ps.id} value={ps.id}>
                            {ps.status}
                          </option>
                        ))}
                      </select>
                    </label>

                    <label>
                      Subscription Start
                      <DateTimeField
                        value={editProduct?.subscriptionstart}
                        editable={false}
                        onChange={(utcVal) =>
                          setEditProduct({
                            ...editProduct,
                            subscriptionstart: utcVal,
                          })
                        }
                      />
                    </label>

                    <label>
                      Subscription End
                      <DateTimeField
                        value={editProduct?.subscriptionend}
                        editable={true}
                        onChange={(utcVal) =>
                          setEditProduct({
                            ...editProduct,
                            subscriptionend: utcVal,
                          })
                        }
                      />
                    </label>

                    <label>
                      Next Payment Due
                      <DateTimeField
                        value={editProduct?.renewaldate}
                        editable={false}
                        onChange={(utcVal) =>
                          setEditProduct({
                            ...editProduct,
                            renewaldate: utcVal,
                          })
                        }
                      />
                    </label>

                    <label>
                      Total Cost
                      <input
                        value={editProduct?.totalcost || ""}
                        onChange={(e) =>
                          setEditProduct({
                            ...editProduct,
                            totalcost: e.target.value,
                          })
                        }
                      />
                    </label>
                    <label>
                      Vat
                      <input
                        value={editProduct?.vat || ""}
                        onChange={(e) =>
                          setEditProduct({
                            ...editProduct,
                            vat: e.target.value,
                          })
                        }
                      />
                    </label>

                    
                    <label>
                      Paypal Email
                      <input
                        value={editProduct?.paypalemail || ""}
                        onChange={(e) =>
                          setEditProduct({
                            ...editProduct,
                            paypalemail: e.target.value,
                          })
                        }
                      />
                    </label>
                    <label>
                      Paypal Plan Id
                      <input
                        value={editProduct?.paypalplanid || ""}
                        readOnly
                      />
                    </label>
                    
                    <label>
                      Payment Method
                      <input
                        value={editProduct?.paymentmethod || ""}
                        readOnly
                      />
                    </label>

                    <label className="checkbox-label">
                      Recurring
                      <input
                        type="checkbox"
                        checked={!!editProduct?.recurring}
                        readOnly
                      />
                    </label>
                    <label className="checkbox-label">
                      Is Paypal Email Used
                      <input
                        type="checkbox"
                        checked={!!editProduct?.ispaypalemailused}
                        readOnly
                      />
                    </label>
                    
                    
                    <label>
                      Reason Of Cancellation
                      <textarea
                        value={editProduct?.reasonofcancellation || ""}
                        readOnly
                        rows={1}
                        // onChange={(e) =>
                        //   setEditProduct({
                        //     ...editProduct,
                        //     reasonofcancellation: e.target.value,
                        //   })
                        // }
                      />
                    </label>
                    

                    <div className="btn-row">
                      <button
                        className="btn-submit-edit"
                        onClick={handleSubmitProduct}
                      >
                        Submit
                      </button>
                      <button
                        className="btn-cancel-edit"
                        onClick={handleCancelEditProduct}
                      >
                        Cancel
                      </button>
                    </div>
                  </div>
                )}
              </div>
            )}
          </div>
        </div>
      )}

      {/* Add user Modal */}
      {showModal && (
        <div className="modal-overlay">
          <div className="modal-add">
            <h2>Add User</h2>
            {successMsg && (
              <p
                style={{
                  color: "green",
                  textAlign: "center",
                  fontSize: "14px",
                }}
              >
                {successMsg}
              </p>
            )}
            {errorMsg && (
              <p
                style={{ color: "red", textAlign: "center", fontSize: "14px" }}
              >
                {errorMsg}
              </p>
            )}
            <form
              className="form-grid-add"
              onSubmit={(e) => {
                e.preventDefault();
                let newErrors = {};

                if (!formData.username) {
                  newErrors.username = "Username is required";
                } else {
                  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                  if (!emailRegex.test(formData.username)) {
                    newErrors.username = "Please enter a valid email address";
                  }
                }

                if (!formData.password) {
                  newErrors.password = "Password is required";
                }

                setAdderror(newErrors);

                if (Object.keys(newErrors).length === 0) {
                  handleSubmitUser(e); // ✅ only submit if no errors
                }
              }}
            >
              <label>
                Username (email) *
                <input
                  name="username"
                  value={formData.username}
                  onChange={handleChange}
                  type="text"
                  required
                />
                {adderror.username && (
                  <div className="error">{adderror.username}</div>
                )}
              </label>
              <label>
                First Name
                <input
                  name="firstname"
                  value={formData.firstname}
                  onChange={handleChange}
                  type="text"
                />
              </label>
              <label>
                Last Name
                <input
                  name="surname"
                  value={formData.surname}
                  onChange={handleChange}
                  type="text"
                />
              </label>
              <label>Password *
              <div className="password-wrapper">
                <input
                  type={showPassword ? "text" : "password"}
                  placeholder="Enter password"
                  value={formData.password}
                  onChange={handleChange}
                  name="password"
                  required
                />
                <span
                  className="password-toggle"
                  onClick={() => setShowPassword((prev) => !prev)}
              >
                  {showPassword ? "Hide" : "Show"}
              </span>
              </div>
              </label>
              {adderror.password && (
                  <div className="error">{adderror.password}</div>
                )}
              {/* <label>
                Password *
                <input
                  name="password"
                  value={formData.password}
                  onChange={handleChange}
                  type="password"
                  required
                /> */}
                
              {/* </label> */}
              <label>
                Mobile Number
                <input
                  name="mobilenumber"
                  value={formData.mobilenumber}
                  onChange={handleChange}
                  type="text"
                />
              </label>
              <label>
                User Status
                <select
                  value={formData.userstatusid}
                  onChange={(e) => {
                    const { value } = e.target;
                    setFormData((prev) => ({
                      ...prev,
                      userstatusid: value,
                    }));
                  }}
                >
                  <option value="1">Active</option>
                  <option value="2">Inactive</option>
                </select>
              </label>
              <label>
                User Type
                <select
                  value={formData.usertypeid}
                  onChange={(e) => {
                    const { value } = e.target;
                    setFormData((prev) => ({
                      ...prev,
                      usertypeid: value,
                    }));
                  }}
                >
                  {userTypeData.map((item) => (
                    <option key={item.id} value={item.id}>
                      {item.type}
                    </option>
                  ))}
                </select>
              </label>
              <label>
              </label>
              
              {/* Modal actions */}
              <div className="modal-actions">
          <button type="submit" className="save-btn-add">
            Submit
          </button>
          <button
            type="button"
            className="cancel-btn-add"
            onClick={() => setShowModal(false)}
          >
            Cancel
          </button>
        </div>
      </form>
          </div>
        </div>
      )}
    </div>
  );
}
